module.exports = __webpack_public_path__ + "static/media/background.5a1893e2.png";